<template>
  <div>
    <PageHeader />
    <h2>{{ t('trackYourShipments') }}</h2>

    <div class="tracking-form d-flex align-items-center">
      <b-form-input v-model="trackingNumber" :placeholder="t('shipmentId')" :aria-label="t('shipmentId')" />

      <b-button
        class="btn-green ml-3 px-0 d-flex align-items-center justify-content-center"
        :aria-label="t('trackYourShipments')"
        :disabled="trackingNumber.length === 0"
        @click="tracking"
      >
        <SearchIcon />
      </b-button>
    </div>

    <p v-if="savedTracking.length > 0">{{ t('previousSearches') }}</p>
    <ul class="previous-searches">
      <li v-for="number in savedTracking" :key="number" class="mb-2">
        <b-button class="searches-button mt-2 mt-md-0" @click="trackingPrevious(number)">
          {{ number }}
        </b-button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { BButton, BFormInput } from 'bootstrap-vue-next'
import { ref, onMounted, defineComponent, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { DETAILS_PAGE } from '@/consts/Router'
import PageHeader from '@/views/Layouts/Parts/PageHeader.vue'
import SearchIcon from '@/views/Elements/Icons/SearchIcon.vue'

export default defineComponent({
  name: 'SearchPage',
  components: {
    PageHeader,
    BButton,
    BFormInput,
    SearchIcon,
  },
  setup() {
    const { t } = useI18n()
    const trackingNumber: Ref<string> = ref('')
    const savedTracking: Ref<string[]> = ref([])
    const router = useRouter()

    onMounted(() => {
      const saved = localStorage.getItem('savedTracking')
      if (saved) {
        const val = JSON.parse(saved)
        if (Array.isArray(val)) {
          savedTracking.value = val
        }
      }
    })

    const tracking = () => {
      savedTracking.value.push(trackingNumber.value)
      localStorage.setItem('savedTracking', JSON.stringify([...new Set(savedTracking.value)]))
      redirect()
    }

    const trackingPrevious = (number: string) => {
      trackingNumber.value = number
      redirect()
    }

    const redirect = () => {
      const to = {
        name: DETAILS_PAGE,
        params: { id: trackingNumber.value },
      }

      if (router.resolve(to).fullPath !== router.currentRoute.value.fullPath) {
        router.push(to)
      }
    }

    return {
      t,
      trackingNumber,
      savedTracking,
      tracking,
      trackingPrevious,
    }
  },
})
</script>
